import {  Routes, Route, Navigate, HashRouter } from "react-router-dom";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";

function ProtectedRoute({ children }) {
  // Accept either the older 'token' key or the mobile auth key 'authKey'.
  // Using Navigate avoids a full page reload which could cause loops on mobile.
  const token = localStorage.getItem("token") || localStorage.getItem("authKey");
  if (!token) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </HashRouter>
  );
}